import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import Box from '@mui/material/Box';

import ViewPage from '../../../Components/ViewPage';

import {
  ROUTE_ANALYTICS,
  ROUTE_ANALYTICS_PERFORMANCE,
} from '../../../Routes/routes';

const breadcrumbs = (t) => [{
  title: t('Views.analyticsTitle'),
  route: `/${ROUTE_ANALYTICS}`,
}, {
  title: t('Analytics.performanceTitle'),
  route: `/${ROUTE_ANALYTICS_PERFORMANCE}`,
}];

function Performance({
  toggleDrawer,
  loading,
}) {
  const { t } = useTranslation();
  return (
    <ViewPage
      title={t('Analytics.performanceTitle')}
      toggleDrawer={toggleDrawer}
      loading={loading}
      breadcrumbs={breadcrumbs(t)}
    >
      <Box
        data-testid="Performance-View-Container"
        sx={{
          mt: 1,
          display: 'flex',
          flex: 1,
          flexDirection: 'column',
        }}
      />
    </ViewPage>
  );
}

Performance.propTypes = {
  toggleDrawer: PropTypes.func,
  loading: PropTypes.bool,
};

Performance.defaultProps = {
  toggleDrawer: () => {
    // Default
  },
  loading: false,
};

export default Performance;
